<template>
  <div>
    <div class="take-over-toolbar__wrapper">
      <div v-if="!isBackstage">
        <div
          v-if="!showTakeOver"
          class="take-over-toolbar"
        >
          <PresentationViewOnlyInfoBar
            v-if="canUseShareDocs && presentation.id"
            :current-user="currentUser"
            :presentation="presentation"
            @reload="reloadPage"
          />
          <div
            v-else
            class="take-over--editor-info"
          >
            <aha-avatar
              class="take-over--avatar"
              :name="currentUser.firstName"
              :image="currentUser.avatar"
              :id="currentUser.id"
            />

            <p class="take-over--editor-text">
              {{ $i18nPresenter.t('You can view and present this presentation.') }}
              <a
                class="font-bold text-link float-right"
                @click="reloadPage"
                v-tooltip="$i18nPresenter.t('Refresh to view the latest version')"
              >
                {{ $i18nPresenter.t('Refresh') }}</a>
            </p>
          </div>
        </div>
        <div
          v-else-if="presentation.takenOverBy !== currentUser.id"
          class="take-over-toolbar"
        >
          <div class="take-over--editor-info">
            <!-- <aha-avatar
              class="take-over--avatar"
              :name="presentation.TakenOverByUser.firstName"
              :image="presentation.TakenOverByUser.avatar"
              :id="presentation.TakenOverByUser.id"
            /> -->
            <!-- <p
              class="take-over--editor-text"
              v-html="$i18nPresenter.t('xxxIsEditingYouCanOnlyViewIt', {
                name: presentation.TakenOverByUser.name,
                email: presentation.TakenOverByUser.email
              })"
            >
            </p> -->
            <p class="take-over--editor-text" v-if="presentation.TakenOverByUser">
              {{ $i18nPresenter.t('To edit please take over from') }} <b>{{ presentation.TakenOverByUser.email }}</b>
            </p>
          </div>
          <div
            class="take-over--actions"
          >
            <aha-antd-button
              v-aha-emit-action
              name="take-over-button"
              variant="secondary"
              @click="openTakeOverModal()"
            >
              {{ $i18nPresenter.t('Take over') }}
            </aha-antd-button>
            <aha-antd-button
              v-aha-emit-action
              name="reload-button"
              variant="text"
              class="font-semibold"
              @click="reloadPage"
              v-tooltip="$i18nPresenter.t('Refresh to view the latest version')"
            >
              {{ $i18nPresenter.t('Refresh') }}
            </aha-antd-button>
          </div>
        </div>
      </div>
      <TakeOverModal
        v-if="isShowTakeOverModal"
        :submitting="submitting"
        :presenting="presentation.presenting"
        @hide="closeTakeOverModal"
        @takeOver="takeover()"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import PresentationApi from '@/api/presentation'
import TakeOverModal from '@/components-v2/presentation-editor/collaboration/TakeOverModal.vue'
import PresentationViewOnlyInfoBar from '@/components-v2/presentation-editor/collaboration/PresentationViewOnlyInfoBar.vue'

// utils
import Utils from '@/util'

import constants from '@/constant'
import EventBus from '@/eventBus'

export default {
  components: {
    TakeOverModal,
    PresentationViewOnlyInfoBar,
  },
  data() {
    return {
      submitting: false,
      isShowTakeOverModal: false,
      permissions: constants.permissions,
      workspace: constants.workspace,
    }
  },
  computed: {
    ...mapGetters(['isBackstage']),
    ...mapGetters('multipleSessions', ['canUseShareDocs']),
    ...mapState({
      presentation: (state) => state.presentation,
      presentationEditors: (state) => state.presentationEditors,
      isDisableEditPresentation: (state) => state.isDisableEditPresentation,
      canEditPresentation: (state) => state.canEditPresentation,
      currentUser: (state) => state.currentUser,
    }),
    isShareWithMePresentation() {
      return this.presentation.accountId
    },
    isShowActiveEditingUser() {
      if (this.isBackstage) return false
      return (this.presentation.TakenOverByUser &&
        this.presentation.TakenOverByUser.id !== this.currentUser.id)
        || (this.presentationEditors.length > 1)
    },
    showNoteCanEditThisSlide() {
      return this.presentationEditors.length > 1 ||
        (this.presentationEditors.length === 1 &&
        this.presentationEditors[0].id !== this.presentation.takenOverBy)
    },
    showTakeOver() {
      // if (!this.presentation.permissions && this.presentation.ownerId === this.currentUser.id) {
      // if (!this.presentation.permissions && this.presentation.userId === this.currentUser.id) {
      //   return true
      // }
      // return this.presentation.permissions &&
      //   this.presentation.permissions.includes(this.permissions.RENAME_PRESENTATION)

      // if (!this.presentation.permissions && this.presentation.userId === this.currentUser.id) {
      //   return true
      // }
      return this.presentation.permissions &&
        this.presentation.permissions.includes(this.permissions.RENAME_PRESENTATION)
    },
  },
  mounted() {
    EventBus.$on('take-over-event', async (callback) => {
      await this.takeover()
      if (callback) {
        callback()
      }
    })
  },
  destroyed() {
    EventBus.$off('take-over-event')
  },
  methods: {
    openTakeOverModal() {
      this.isShowTakeOverModal = true
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Open Modal')
    },
    closeTakeOverModal() {
      this.isShowTakeOverModal = false
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Close Modal')
    },
    async takeover() {
      this.submitting = true
      try {
        await PresentationApi.takeOver(this.presentation.id)
        // window.location.reload()
        Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Succeeded')
      } catch (e) {
        Sentry.captureException(e)
        if (e.status === 403) window.location.reload()
        Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Take Over > Failed')
      }

      // Looks dumb, I know. Wait 1s to synchronize with socket message to update UI properly
      setTimeout(() => {
        this.submitting = false
        this.isShowTakeOverModal = false
      }, 1000)
    },
    reloadPage() {
      Utils.mixpanelTracking(constants.eventCategories.PRESENTATION_EDITOR, 'Collaboration > Refresh')
      setTimeout(() => {
        window.location.reload()
      }, 500)
    },
  },
}
</script>

<style lang="scss">
.take-over-toolbar__wrapper {
  @apply relative;
  box-shadow: 0px 10px 38px 0px #525F7F08;
}
.take-over-toolbar {
  @apply border-b border-base-30 bg-base-0 flex items-center my-3;
  @apply rounded-tr-lg rounded-br-lg rounded-tl-lg rounded-bl-lg;
  padding: 12px 16px 11px;
  width: calc(100% - 4px);
  margin-left: 4px;
  max-height: 100px;
  &.p-0 {
    padding: 0;
  }
}

.take-over--editor-info {
  @apply flex flex-row items-center;
  padding-left: 5px;
  padding-right: 10px;
  flex: 1;
}
.border-left {
  width: 5px;
  height: 28px;
  border-radius: 6px;
  margin-right: 6px;
}
.take-over--avatar {
  @apply flex-grow-0 flex-shrink-0;
}
.take-over--editor-text {
  @apply pl-2 mx-1;
  width: 100%;
  word-break: break-word;
  margin-left: 0;
  padding-left: 4px;
  &.can-only-view{
    margin-left: 4px;
  }
}
.take-over--actions {
  @apply flex flex-row items-center mr-1 gap-4;
}

svg.icon-reload.path-fill-current.inline-block{
  &::v-deep{
    path {
      fill: rgba(180, 188, 207, 1);
    }
  }
  &:hover{
    &::v-deep{
      path {
        fill: rgba(106, 30, 187, 1);
      }
    }
  }
}
</style>
